import { IWishlist } from "@app/types/wishlist"
import { parsePhoneNumber } from "libphonenumber-js"

export const formatPhoneNumber = (phone: string) => {
  try {
    return parsePhoneNumber(phone, "AU")?.number
  } catch (e: unknown) {
    console.debug("Error parsing phone number:", e)
    return null
  }
}

export const selectDefaultWishlist = (
  wishlists: IWishlist[]
): IWishlist | null => {
  return (
    wishlists.find(
      (wishlist) =>
        wishlist.is_default_wishlist || wishlist.title.includes("Default")
    ) ||
    wishlists[0] ||
    null
  )
}
